module.exports = __webpack_public_path__ + "img/logo1_new.015f197c.png";